function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import utils from '../utils';
import { VList } from '../components/VList';
import DanmakuListItem from './danmakuListItem';
var DanmakuList = function () {
    function DanmakuList(player, el) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, DanmakuList);
        this.player = player;
        this.el = el;
        this.template = this.player.template;
        this.data = [];
        this.listData = [];
        this.sortedBy = 'time';
        this.sortReverse = false;
        this.typeFilter = new Set();
        this.originFilter = new Set();
        this.autoScroll = options.danmakuListAutoScroll || false;
        this.init();
    }
    _createClass(DanmakuList, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                var $ = this.el.querySelector.bind(this.el);
                this.template.danmaku_list_col_time = $('.mfunsPlayer-danmaku-list-head .col-time');
                this.template.danmaku_list_col_text = $('.mfunsPlayer-danmaku-list-head .col-text');
                this.template.danmaku_list_col_date = $('.mfunsPlayer-danmaku-list-head .col-date');
                this.template.danmaku_list_container = $('.mfunsPlayer-danmaku-list-container');
                this.template.danmaku_list_status = $('.mfunsPlayer-danmaku-list-status');
                this.template.danmaku_list_autoscroll = $('.mfunsPlayer-danmaku-list-autoscroll');
                this.template.danmaku_list_col_time.onclick = function () {
                    _this.setAutoScroll(false);
                    if (_this.sortedBy == 'time') {
                        _this.sort('time', !_this.sortReverse);
                    } else {
                        _this.sort('time', false);
                    }
                };
                this.template.danmaku_list_col_date.onclick = function () {
                    _this.setAutoScroll(false);
                    if (_this.sortedBy == 'date') {
                        _this.sort('date', !_this.sortReverse);
                    } else {
                        _this.sort('date', false);
                    }
                };
                this.template.danmaku_list_autoscroll.onclick = function () {
                    _this.setAutoScroll(!_this.autoScroll);
                };
                this.list = new VList({
                    el: this.template.danmaku_list_container,
                    getData: function getData() {
                        return _this.listData;
                    },
                    itemHeight: 24,
                    createItem: function createItem(danmaku, i) {
                        return new DanmakuListItem(_this.player, danmaku, i).el;
                    },
                    overflow: 5
                });
                this.danmakuLoadingFailed = false;
                if (this.player.danmaku.loaded) {
                    this.fill(this.player.danmaku.dan);
                } else {
                    this.setStatus('loading');
                }
                this.player.on('danmaku_load_end', this.fill.bind(this));
                this.player.on('danmaku_load_start', this.clear.bind(this));
                this.player.on('danmaku_load_failed', function () {
                    _this.danmakuLoadingFailed = true;
                }.bind(this));
                this.player.on('danmaku_filter', function (_ref) {
                    var key = _ref.key, value = _ref.value;
                    if (key == 'type') {
                        _this.typeFilter = new Set(value);
                    } else if (key == 'origin') {
                        _this.originFilter = new Set(value);
                    }
                    _this.reload();
                });
                this.player.on('timeupdate', function () {
                    if (_this.autoScroll) {
                        _this.locateByTime(_this.player.video.currentTime);
                    }
                });
                this.list.el.addEventListener('wheel', function () {
                    _this.setAutoScroll(false);
                }, { passive: true });
                this.list.el.addEventListener('mousedown', function () {
                    _this.setAutoScroll(false);
                });
                this.setAutoScroll(this.autoScroll);
            }
        },
        {
            key: 'fill',
            value: function fill(dan) {
                this.data = dan;
                if (this.danmakuLoadingFailed) {
                    this.setStatus('failed');
                } else if (!this.data.length) {
                    this.setStatus('empty');
                } else {
                    this.reload();
                    this.setStatus(true);
                }
            }
        },
        {
            key: 'sort',
            value: function sort() {
                var _this2 = this;
                var sortedBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.sortedBy;
                var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.sortReverse;
                this.sortedBy = sortedBy;
                this.sortReverse = reverse;
                this.listData.sort(function (a, b) {
                    return _this2.sortReverse ? b[_this2.sortedBy] - a[_this2.sortedBy] : a[_this2.sortedBy] - b[_this2.sortedBy];
                });
                this.list.reload();
            }
        },
        {
            key: 'reload',
            value: function reload() {
                var _this3 = this;
                var colorFilter = this.typeFilter.has('color');
                var specialFilter = this.typeFilter.has('special');
                this.listData = this.data.filter(function (item) {
                    return !(_this3.originFilter.has(item.origin) || _this3.typeFilter.has(item.type) || colorFilter && item.color != 16777215 || specialFilter && item.mode > 6);
                });
                this.listData.sort(function (a, b) {
                    return _this3.sortReverse ? b[_this3.sortedBy] - a[_this3.sortedBy] : a[_this3.sortedBy] - b[_this3.sortedBy];
                });
                this.list.reload();
                if (this.autoScroll) {
                    this.locateByTime(this.player.video.currentTime);
                }
            }
        },
        {
            key: 'clear',
            value: function clear() {
                this.list.clear();
                this.danmakuLoadingFailed = false;
                this.setStatus('loading');
            }
        },
        {
            key: 'setStatus',
            value: function setStatus(status) {
                this.template.danmaku_list_status.classList.toggle('status-loading', status === 'loading');
                this.template.danmaku_list_status.classList.toggle('status-failed', status === 'failed');
                this.template.danmaku_list_status.classList.toggle('status-empty', status === 'empty');
                console.log('弹幕加载状态' + status);
            }
        },
        {
            key: 'locateByTime',
            value: function locateByTime(time) {
                var _this$listData$viewEn;
                var viewEnd = this.list.viewEnd;
                if (((_this$listData$viewEn = this.listData[viewEnd]) === null || _this$listData$viewEn === void 0 ? void 0 : _this$listData$viewEn.time) > time) {
                    viewEnd = 0;
                }
                while (((_this$listData = this.listData[viewEnd + 1]) === null || _this$listData === void 0 ? void 0 : _this$listData.time) <= time) {
                    var _this$listData;
                    viewEnd++;
                }
                this.list.locateEnd(viewEnd);
            }
        },
        {
            key: 'setAutoScroll',
            value: function setAutoScroll(bool) {
                this.autoScroll = bool;
                if (bool) {
                    this.sort('time', false);
                    this.locateByTime(this.player.video.currentTime);
                }
                this.template.danmaku_list_autoscroll.innerText = '列表滚动['.concat(bool ? '开' : '关', ']');
            }
        }
    ]);
    return DanmakuList;
}();
export default DanmakuList;